<template>
  <div class="openApp">

  </div>
</template>

<script>
  import { shortUrlCode } from '@/api/org'
  export default {
    data() {
      return {

      }
    },
    created() {
      if(this.$route.params.code){
        this.openApp()
      }else {
        alert('url 参数错误！')
      }
    },
    methods: {
      openApp(data){
        window.setTimeout(()=>{
          // window.location.href = 'http://192.168.1.105:8002/a/'+this.$route.params.code;
          window.location.href = 'https://wx.anttalk.vip/a/'+this.$route.params.code;
        }, 200)
      }
    }
  }
</script>

<style lang="less" scoped>
  .openApp{

  }
</style>